import React, { useState } from 'react';
import { connect } from 'react-redux';
import NoSSR from 'react-no-ssr';
import { ApplicationState } from '../../types/state/storeTypes';
import CartSubscriptionBlock from './CartSubscriptionBlock';
import {
  fallbackVariantLabel
} from '../../helpers/pages/collections/collectionsHelpers';
import { MainLinkButton } from '../styled/buttons/MainLinkButton';
import { isCreditBasedLegacy } from '../../helpers/subscriptionHelpers';

function LegacyCreditsPurchaseBlock(props) {
  const { collection, subscription, user } = props;

  if (!isCreditBasedLegacy(subscription)) {
    return <></>;
  }

  if (collection?.contributor?.id || collection?.library_id == 3) {
    return (
      <div className="">
        <p className="text-gray-500 py-4">This product cannot be purchased using legacy subscription plans.</p>
        <MainLinkButton
          href="/pricing"
          className="my-3 h-[56px] !py-4 px-4 w-full"
          variant="blue">
          Get Access
        </MainLinkButton>
      </div>
    );
  }

  if (subscription.legacy_current_credit_balance < collection.credit_price) {
    return (
      <>
        <p className="text-gray-500 py-4">You do not have enough credits to purchase this product.</p>
        <MainLinkButton
          href="/pricing"
          className="my-3 h-[56px] !py-4 px-4 w-full"
          variant="blue">
          Upgrade Plan
        </MainLinkButton>
      </>
    );
  }

  // HOTFIX for recent product release - filter out inactive variants
  // This is because we won't be directly selling 2K for recent release.
  // The future fix is to change back-end to compensate for this.
  const variants = collection.collection_variants.filter(variant => {
    if (['BW2', 'OW1', 'LSW1', 'WFA1'].includes(collection.sku)) {
      return variant.resolution.includes('4K');
    }
    return true;
  });

  const optionables = variants
    .sort((v1, v2) => v1.price - v2.price)
    .map((p) => p.optionables);
  const specs = {};
  const firstVariant = variants.sort((v1, v2) => v1.price - v2.price)[0];
  const [selectedVariant, setSelectedVariant] = useState(firstVariant);
  const buttonClasses =
    'rounded-[5px] border px-5 py-1 flex align-middle items-center gap-2 text-[13px] justify-center uppercase py-2 text-md';

  for (const p of optionables) {
    for (const spec of p) {
      if (specs[spec.type] == undefined) {
        specs[spec.type] = String(spec.value);
      } else {
        if (specs[spec.type].toLowerCase() == String(spec.value).toLowerCase()) {
          continue;
        }
        specs[spec.type] += ' / ' + spec.value;
      }
    }
  }

  if (collection.archived) {
    return (
      <div className="py-3">
        <p className="text-gray-500 py-4">This product is no longer available.</p>
      </div>
    );
  }

  return (
    <div className="py-3">
      {variants.length > 1 && (
        <>
          <label className="block pt-3 text-[15px]">Choose Resolution:</label>
          <div className="flex gap-3 py-3">
            {variants
              .sort((v1, v2) => v1.price - v2.price)
              .map((v) => (
                <button
                  key={v.id}
                  onClick={() => setSelectedVariant(v)}
                  className={
                    buttonClasses +
                    ' ' +
                    (selectedVariant.id == v.id
                      ? 'text-a-blue border-a-blue bg-[#24C1FF] bg-opacity-10'
                      : 'text-a-light-gray border-a-light-gray')
                  }
                >
                  {v.optionables.find((o) => o.type == 'resolution')?.value ||
                    fallbackVariantLabel(v)}
                </button>
              ))}
          </div>
        </>
      )}

      <div className="mt-6 mb-6">
        <CartSubscriptionBlock
          collection={collection}
          subscription={subscription}
          modifiedPrice={99999}
          selectedVariant={selectedVariant}
          user={user}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.auth.user,
  subscription: state.auth.subscription
});

const ConnectedLegacyCreditsPurchaseBlock = connect(mapStateToProps)(LegacyCreditsPurchaseBlock);

export default (props) => (
  <NoSSR>
    <ConnectedLegacyCreditsPurchaseBlock {...props} />
  </NoSSR>
);
